import InternalChatAPI from 'dashboard/api/internalChat';
import { ownChannelGeneration } from './internalChatMessageHelpers';

const pendingWrites = new Map();

export const channelAggregatesChanged = (current, previous) =>
  !current ||
  ['unread_count', 'last_activity_at', 'messages_count'].some(
    key => current[key] !== previous[key]
  );

export const writeReadReceipt = async (
  { commit, dispatch, state, rootGetters },
  channelId,
  unread = false
) => {
  const accountId = rootGetters.getCurrentAccountId;
  const generation = state.contextGeneration;
  const ownsChannel = ownChannelGeneration(state, channelId);
  const key = `${accountId}:${channelId}`;
  commit('START_READ_REQUEST', channelId);
  const request = state.readRequestGeneration[channelId];
  const perform = async () => {
    if (
      generation !== state.contextGeneration ||
      accountId !== rootGetters.getCurrentAccountId ||
      !ownsChannel()
    )
      return null;
    const previous = state.channels.find(channel => channel.id === channelId);
    if (!previous) return null;
    const response =
      await InternalChatAPI[unread ? 'markUnread' : 'markRead'](channelId);
    if (!ownsChannel()) return null;
    const current = state.channels.find(channel => channel.id === channelId);
    const changed = channelAggregatesChanged(current, previous);
    commit('APPLY_READ_RECEIPT', {
      channelId,
      request,
      previous,
      unreadCount: response.data.unread_count,
    });
    if (
      current &&
      request === state.readRequestGeneration[channelId] &&
      changed
    )
      await dispatch('fetchChannel', channelId);
    return response.data;
  };
  const previousWrite = pendingWrites.get(key);
  const operation = previousWrite
    ? previousWrite.catch(() => null).then(perform)
    : perform();
  pendingWrites.set(key, operation);
  try {
    return await operation;
  } finally {
    if (pendingWrites.get(key) === operation) pendingWrites.delete(key);
  }
};
